module.exports = {
  common: {
    clearCache: '/clear/cache', //执行清空缓存
    serverRestart: '/server/restart' //执行重启服务
  }
};
